// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;
const azureActiveDirectoryAppId =
  process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_ID;
const appName = process.env.REACT_APP_SIPPIO_TITLE;
const appVersion = process.env.REACT_APP_BUILD_VERSION;

function setLoggerOptionsBaseOnEnv() {
  if (process.env.REACT_APP_ENV === "development") {
    return {
      logLevel: LogLevel.Verbose,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            console.warn(message);
            return;
        }
      },
      piiLoggingEnabled: true,
    };
  } else {
    return;
  }
}

const msalConfig = {
  auth: {
    clientId: azureActiveDirectoryAppId,
    authority: "https://login.microsoftonline.com/organizations",
    redirectUri: window.location.origin + "/signin",
    postLogoutRedirectUri: window.location.origin + "/signin",
  },
  cache: {
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
    cacheLocation: "localStorage",
    secureCookies: isIE || isEdge || isFirefox,
    claimsBasedCachingEnabled: isIE || isEdge || isFirefox,
  },
  system: {
    loggerOptions: setLoggerOptionsBaseOnEnv(),
    asyncPopups: true,
    iframeHashTimeout: 60000,
    allowRedirectInIframe: true,
  },
  telemetry: {
    application: {
      appName: appName,
      appVersion: appVersion,
    },
  },
};

export const loginRequest = {
  prompt: "select_account",
  scopes: ["https://graph.microsoft.com/.default"],
};

export const logoutRequest = {
  mainWindowRedirectUri: window.location.origin + "/signin",
};

const msalInstanceInitialize = new PublicClientApplication(msalConfig);
msalInstanceInitialize.initialize();

export const msalInstance = msalInstanceInitialize;
